import {styled} from '@mui/material';

const Container = styled('div')`
	width: 100%;
	padding: 32px;

	@media (max-width: 599px) {
		padding: 16px;
	}
`;

export {Container};
